import { GetterTree } from 'vuex';
import RootState from '@/store/root_state';
import { HelperAppState } from './state';

const getters: GetterTree<HelperAppState, RootState> = {
  isLoadingApp: state => {
    return state.loading;
  },
};

export default getters;
